<script lang="ts">
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';

    function buildListHeaderUri(rule: string, count: number): string {
        return `/nav-grimm/list-header/${encodeURIComponent(rule)}?productCount=${count}`;
    }

    interface Props {
        rule: string;
        count: number;
    }

    let { rule, count }: Props = $props();

    const src = $derived(buildListHeaderUri(rule, count));
</script>

<DynamicEsi {src} name="NavListHeader" />
